import styled from 'styled-components'
import { inputBorderRadius } from './variables'
import Input from './Input'

const InputGroup = styled.div`
  display: flex;
  position: relative;

  /* TODO: Better type this */
  > ${Input as any /* sc-selector */}:not(:first-child) {
    border-radius: 0 ${inputBorderRadius} ${inputBorderRadius} 0;
  }

  > ${Input as any /* sc-selector */}:not(:last-child) {
    border-radius: ${inputBorderRadius} 0 0 ${inputBorderRadius};
  }
`

export default InputGroup
